





























































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";

import { TransactionEditSearchItem } from "@/shared/types";
import { formatDateString } from "@/shared/dateString";
import { formatCurrency } from "@/shared/currency";
import { useNotifierStore } from "@/shared/store/notifier";
import { useTransactionEditStore } from "@/admin/store/transactionEdit";


@Component({})
export default class Edit extends Vue {
  formatCurrency = formatCurrency;
  formatDateString = formatDateString;

  notifierStore = useNotifierStore();
  transactionEditStore = useTransactionEditStore();

  @Prop() transaction: TransactionEditSearchItem;
  updatedTransaction: TransactionEditSearchItem = null;

  isSaving = false;

  created (): void {
    this.onTransactionChange(this.transaction);
  }

  @Watch("transaction", { deep: true })
  onTransactionChange (item: TransactionEditSearchItem) {
    this.updatedTransaction = { ...item };
  }

  get invertTransactionAmountCopy (): string {
    return `Convert to ${this.transaction.amount > 0 ? "debit" : "credit"}`;
  }

  get yearValidation () {
    const max = new Date().getFullYear() + 1;

    return {
      numeric: true,
      required: true,
      max_value: max,
      min_value: max - 10
    };
  }

  get hasChanges () {
    return !(this.transaction.effectiveYear === this.updatedTransaction.effectiveYear
      && this.transaction.transactionType === this.updatedTransaction.transactionType
      && this.transaction.isArchived === this.updatedTransaction.isArchived
      && this.transaction.isAmountInverted === this.updatedTransaction.isAmountInverted
      && this.transaction.description === this.updatedTransaction.description);
  }

  get submitTitle () {
    if (!this.hasChanges) {
      return "No changes";
    }
    if (this.$validator.errors.any()) {
      return "Validation error";
    }
    if (this.isSaving) {
      return "Save in progress";
    }

    return "Save changes";
  }

  get isSubmitEnabled () {
    return this.hasChanges && !this.$validator.errors.any();
  }

  availableTransactionTypes = [
    { value: "none", text: "other" },
    { value: "payrollEmployer", text: "payrollEmployer" },
    { value: "payrollRecurring", text: "payrollRecurring" },
    { value: "payrollOneTime", text: "payrollOneTime" },
    { value: "reimbursement", text: "reimbursement" },
    { value: "debitCard", text: "debitCard" },
    { value: "personalContribution", text: "personalContribution" },
    { value: "payrollPostTax", text: "payrollPostTax" },
    { value: "fee", text: "fee" },
    { value: "investment", text: "investment" },
    { value: "disbursement", text: "disbursement" }];

  onCancelClick () {
    this.$router.go(-1);
  }

  get transactionTypeFeedbackState () {
    if (this.transaction.transactionType === this.updatedTransaction.transactionType) {
      return null;
    }
    return true;
  }

  onFormSubmit () {
    if (this.isSubmitEnabled) {
      this.isSaving = true;

      this.transactionEditStore.editTransaction({
        transactionId: this.transaction.id,
        effectiveYear: this.updatedTransaction.effectiveYear,
        transactionType: this.updatedTransaction.transactionType,
        isArchived: this.updatedTransaction.isArchived,
        isAmountInverted: this.updatedTransaction.isAmountInverted,
        description: this.updatedTransaction.description
      })
        .then(() => { this.notifierStore.setSuccess("Save complete"); })
        .finally(() => { this.isSaving = false; });
    }
  }
}
